import t from "@/lang/lang";
import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@/shared/components/ui/table";
import { Button } from "@/shared/components/ui/button";
import {
  ScrollBodyTable,
  ScrollBodyTableHeader,
} from "@/shared/components/ui/table-scroll-body";
import { ScrollArea, ScrollBar } from "@/shared/components/ui/scroll-area";
import { NavLink } from "react-router";
import { formatDate } from "@/shared/utilities/date";
import { processMilestoneLink } from "@/shared/components/domain/processes/process-milestone-link";

export interface ProcessResult {
  id: string;
  number: string;
  customerId: string;
  customerName: string;
  createdAt: string;
  topResult: boolean;
  currentMilestone: string;
  currentMilestoneId: string;
}

export function ProcessResults({ processes }: { processes: ProcessResult[] }) {
  const enableScroll = processes.length > 4;

  return (
    <div>
      <div className="flex justify-between">
        <h5 className="text-lg font-bold">{t("Vorgänge")}</h5>
        <span className="text-muted-foreground text-sm">
          {processes.length} {t("gefunden")}
        </span>
      </div>
      <ScrollArea className={enableScroll ? "h-[20vh] border-b" : ""}>
        <ScrollBodyTable>
          <ScrollBodyTableHeader>
            <TableRow>
              <TableHead>{t("Nummer")}</TableHead>
              <TableHead>{t("Kunde")}</TableHead>
              <TableHead className="whitespace-nowrap">
                {t("Erstellt am")}
              </TableHead>
              <TableHead>{t("Aktionen")}</TableHead>
            </TableRow>
          </ScrollBodyTableHeader>
          <TableBody>
            {processes.map((process) => (
              <ProcessResultTableRow key={process.id} process={process} />
            ))}
            {processes.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="py-2 text-center">
                  {t("Keine Vorgänge gefunden")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </ScrollBodyTable>
        {enableScroll && <ScrollBar forceMount />}
      </ScrollArea>
    </div>
  );
}

function ProcessResultTableRow({ process }: { process: ProcessResult }) {
  return (
    <TableRow>
      <TableCell className="py-0 whitespace-nowrap">{process.number}</TableCell>
      <TableCell className="py-0 whitespace-nowrap">
        {process.customerName}
      </TableCell>
      <TableCell className="py-0 whitespace-nowrap">
        {formatDate(process.createdAt)}
      </TableCell>
      <TableCell className="py-0 whitespace-nowrap">
        <NavigateToProcess process={process} />
      </TableCell>
    </TableRow>
  );
}

function NavigateToProcess({ process }: { process: ProcessResult }) {
  return (
    <NavLink to={processMilestoneLink(process)}>
      <Button variant="ghost" size="sm">
        <span>{t("Navigieren")}</span>
      </Button>
    </NavLink>
  );
}
